import client from "../client/client";

class DistributionNotificationService {
	send(projectId, payload, cancelToken) {
		return client.post(`/distribution/notifications/projects/${projectId}/send`, {
			payload,
			config: { cancelToken },
		});
	}

	saveDraft(projectId, payload, cancelToken) {
		return client.post(`/distribution/notifications/projects/${projectId}/draft`, {
			payload,
			config: { cancelToken },
		});
	}

	getHistory(projectId, { page, limit }, cancelToken) {
		return client.get(`/distribution/notifications/projects/${projectId}/history`, {
			params: { page, limit },
			config: { cancelToken },
		});
	}

	getTerritories(projectId, cancelToken) {
		return client.get(`/distribution/notifications/projects/${projectId}/territories`, {
			config: { cancelToken },
		});
	}

	getDocuments(projectId, { notificationStatus }, cancelToken) {
		return client.get(`/distribution/notifications/projects/${projectId}/documents`, {
			params: { notificationStatus },
			config: { cancelToken },
		});
	}

	getDocumentTree(projectId, { notificationStatus, search, page, limit }, cancelToken) {
		return client.get(`/distribution/notifications/projects/${projectId}/documents/tree`, {
			params: { notificationStatus, search, page, limit },
			config: { cancelToken },
		});
	}

	getDraft(projectId, cancelToken) {
		return client.get(`/distribution/notifications/projects/${projectId}/draft`, {
			config: { cancelToken },
		});
	}

	deleteDraft(projectId, cancelToken) {
		return client.delete(`/distribution/notifications/projects/${projectId}/draft`, {
			config: { cancelToken },
		});
	}
}

export default new DistributionNotificationService();
